module.exports = __webpack_public_path__ + "static/img/reservation_active.0606b3b3.svg";